import { BasePlacement } from "@popperjs/core";
import classNames from "classnames";
import React from "react";
import { usePopperTooltip } from "react-popper-tooltip";
import styles from "./tooltipPopper.css";

interface Props {
  tooltip: string | JSX.Element;
  placement?: BasePlacement;
  variant?: "default" | "error";
}

export const TooltipPopper = ({
  tooltip,
  placement = "top",
  variant = "default",
  children
}: React.PropsWithChildren<Props>) => {
  const { getTooltipProps, setTooltipRef, setTriggerRef, visible } = usePopperTooltip(
    { placement },
    { strategy: "fixed" }
  );

  const getArrowStyle = () => {
    switch (placement) {
      case "top":
        return styles.top;
      case "left":
        return styles.left;
      case "right":
        return styles.right;
      case "bottom":
        return styles.bottom;
      default:
        return "";
    }
  };

  const getVariantStyle = () => {
    switch (variant) {
      case "error":
        return styles.error;
      default:
        return "";
    }
  };

  return (
    <div ref={setTriggerRef}>
      {children}
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({ className: classNames(styles.container, getVariantStyle()) })}
        >
          <div className={classNames(styles.arrow, getArrowStyle())} />
          {tooltip}
        </div>
      )}
    </div>
  );
};
